var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.61277 0 4.32437 0.948074 2.63557 2.63557C0.948074 4.3242 0 6.61269 0 9C0 11.3873 0.948074 13.6756 2.63557 15.3644C4.3242 17.0519 6.61269 18 9 18C11.3873 18 13.6756 17.0519 15.3644 15.3644C17.0519 13.6758 18 11.3873 18 9C18 6.61269 17.0519 4.32437 15.3644 2.63557C13.6758 0.948074 11.3873 0 9 0ZM9 16.258C7.07549 16.258 5.2293 15.4937 3.86827 14.1316C2.50626 12.7708 1.7419 10.9245 1.7419 8.99991C1.7419 7.07537 2.50626 5.22922 3.86827 3.86819C5.22916 2.50617 7.07546 1.74181 9 1.74181C10.9245 1.74181 12.7707 2.50617 14.1317 3.86819C15.4937 5.22907 16.2581 7.07537 16.2581 8.99991C16.2581 10.9245 15.4937 12.7706 14.1317 14.1316C12.7708 15.4937 10.9245 16.258 9 16.258Z",
    fill: "#30293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12903 8.70972H9.87096V13.3549H8.12903V8.70972Z",
    fill: "#30293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87096 5.51611C9.87096 6.67739 8.12903 6.67739 8.12903 5.51611C8.12903 4.35482 9.87096 4.35482 9.87096 5.51611Z",
    fill: "#30293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2578cc6906e5f3b2314965012ce2bd08.svg";
export { ForwardRef as ReactComponent };